import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
} from "@mui/material";
import bkstApi from "../../api";

export default function SaveDraftOrder(props) {
  const { items } = props;

  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");

  const handleSubmit = () => {
    bkstApi.post(`/my/cart`, { title, items }).then((res) => {
      handleClose();
      props.onSubmit(res.data);
    });
  };

  const handleClose = () => {
    setOpen(false);
    setTitle("");
  };

  return (
    <Box>
      <span
        onClick={props.disabled ? undefined : () => setOpen(true)}
        style={props.disabled ? { pointerEvents: "none", cursor: "not-allowed" } : {}}
        aria-disabled={props.disabled ? "true" : undefined}
      >
        {props.children}
      </span>
      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="xs">
        <DialogTitle>Save Draft Order</DialogTitle>
        <DialogContent>
          <Box pt={4}>
            <TextField
              value={title}
              variant="outlined"
              fullWidth
              id="title"
              label="Title"
              name="title"
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="secondary" variant="outlined" fullWidth>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSubmit}
            disabled={!title}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
